<template>
    <el-scrollbar class="menu-container">
        <el-menu
            class="sidebar-menu"
            :unique-opened="true"
            :default-active="activeMenu"
            :collapse="!$store.getters.sidebarOpened"
        >
            <sidebar-item
                v-for="(route, index) in menuList.filter((item) => !item.hidden)"
                :key="route.path + index"
                :item="route"
                :base-path="route.path"
            />
        </el-menu>
    </el-scrollbar>
</template>

<script setup>
import { computed, onBeforeMount, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import SidebarItem from './SidebarItem.vue'
import { useStore } from 'vuex'

const store = useStore()
const menuList = ref([])
// 菜单默认激活项
const route = useRoute()
const activeMenu = computed(() => {
    const { path } = route
    return path
})

watch(
    () => store.getters.menuList,
    (newVal) => {
        menuList.value = newVal
    }
)
onBeforeMount(() => {
    menuList.value = store.getters.menuList ?? []
})
</script>

<style lang="scss" scoped>
.menu-container {
    --el-menu-bg-color: transparent !important;
    height: 100%;

    :deep(.el-menu) {
        --el-menu-bg-color: transparent !important;
    }
}
</style>
